import { notify } from "@phoenixreisen/reacts/src/notification";
import { isValidVisitorList } from "../../shared/models/api";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Model from "../../shared/models/model";
import VisitorForm from "./visitor.form.r";
const MAX_FORMS = 8;
export const VisitorList = () => {
    const navigate = useNavigate();
    const { schedule } = Model;
    const [visitors, setVisitors] = useState([]);
    const addVisitor = () => {
        const newVa = {};
        const newVi = { gender: "", prename: "", surname: "" };
        setVisitors([...visitors, { v: newVi, e: newVa }]);
    };
    const removeVisitor = (needle) => {
        if (visitors.length > 1) {
            setVisitors(visitors.filter((current) => current.v !== needle));
        }
    };
    const next = (e) => {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        const isSea = !!schedule.schiff.hochsee;
        if (isValidVisitorList(isSea, visitors)) {
            Model.visitors = visitors;
            if (schedule["preis-erwachsener"] > 0 ||
                schedule["reduzierter-preis"] > 0) {
                navigate("/zahlung");
            }
            else {
                navigate("/zusammenfassung");
            }
        }
        else {
            notify({
                status: "error",
                text: "Bitte alle Felder ausfüllen.",
            });
            setVisitors([...visitors]);
        }
    };
    useEffect(() => {
        if (!Model.customer) {
            navigate("/kunde");
        }
        else {
            if (Model.visitors) {
                setVisitors(Model.visitors);
            }
            else {
                addVisitor();
            }
        }
    }, []);
    return (React.createElement("section", { className: "visitors" },
        React.createElement("h3", { className: "pt0" }, "Teilnehmerliste"),
        React.createElement("form", { onSubmit: (e) => next(e) },
            React.createElement("div", null, visitors.map((current, i) => (React.createElement(VisitorForm, { key: i, pos: i, data: current, schedule: schedule, count: visitors.length, remove: () => removeVisitor(current.v), change: (changed) => {
                    setVisitors(visitors.map((v, j) => {
                        return i === j ? changed : v;
                    }));
                } })))),
            visitors.length >= MAX_FORMS && (React.createElement("p", { className: "alert alert--info alert--icon" },
                React.createElement("i", { className: "fas fa-info-circle" }),
                "Wenn Sie mit mehr als 8 Personen anreisen m\u00F6chten, wenden Sie sich bitte direkt an uns: ",
                React.createElement("a", { href: "tel:022892600" }, "0228 92600"),
                ".")),
            React.createElement("div", { className: "flex justify-between" },
                React.createElement("div", null,
                    React.createElement(Link, { to: "/kunde", type: "submit", className: "btn btn--link", onClick: () => (Model.visitors = visitors) },
                        React.createElement("i", { className: "fas fa-arrow-left mr2" }),
                        " Zur\u00FCck")),
                React.createElement("div", null,
                    React.createElement("button", { type: "button", className: "btn btn--secondary ml2", disabled: visitors.length >= MAX_FORMS, onClick: () => addVisitor() },
                        React.createElement("i", { className: "fas fa-plus mr1" }),
                        " Teilnehmer"),
                    React.createElement("button", { type: "submit", className: "ml2", disabled: !visitors.length },
                        "Weiter ",
                        React.createElement("i", { className: "fas fa-arrow-right ml2" })))))));
};
export default VisitorList;
